import { f as c } from "./index835.mjs";
import { i as a } from "./index778.mjs";
import { r as f } from "./index751.mjs";
import { a as n } from "./index836.mjs";
var p = c, _ = a, u = f, b = n, P = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var o = !1, s = {}, e;
  try {
    e = p(Object.prototype, "__proto__", "set"), e(s, []), o = s instanceof Array;
  } catch {
  }
  return function(r, t) {
    return u(r), b(t), _(r) && (o ? e(r, t) : r.__proto__ = t), r;
  };
}() : void 0);
export {
  P as o
};
